module.exports = __webpack_public_path__ + "static/icons/icon-mountain-e6dcd93a68d72993b81f55dcba7915c6.svg";